import React from 'react';
import CampeonesInt from './CampeonesInt';
import CuadroHonorInt from './CuadroHonorInt';
import styles from './PrincipalTorneosInt.module.css';

const PrincipalTorneosInt = (props) => {
  const datosElegidos = props.datosElegidos;

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.titulo}`}>{datosElegidos.tipoTorneo.nombre}</div>
      <div className={`${styles.contenedorCuadros}`}>
        <CuadroHonorInt tipoTorneo={datosElegidos.tipoTorneo} categoria={datosElegidos.categoria} />
        <CampeonesInt tipoTorneo={datosElegidos.tipoTorneo} categoria={datosElegidos.categoria} />
      </div>
    </div>
  );
};

export default PrincipalTorneosInt;
